import { Instagram, MapPin, Phone, Mail } from "lucide-react";
import { CONTACT, STORES } from "../../lib/site";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.6 5.82a4.28 4.28 0 0 1-1.05-2.82h-3.11v12.4a2.4 2.4 0 1 1-2.4-2.4c.16 0 .32.02.47.05V9.9a5.5 5.5 0 0 0-.47-.02 5.5 5.5 0 1 0 5.5 5.5V9.01a7.3 7.3 0 0 0 4.06 1.24V7.14a4.28 4.28 0 0 1-3-1.32z" />
  </svg>
);

const serviceLinks = [
  { label: "Telefoni in vendita", href: "#telefoni" },
  { label: "Offerte mobile", href: "#offerte-mobile" },
  { label: "Fibra casa", href: "#fibra" },
  { label: "Luce e Gas", href: "#luce-gas" },
  { label: "Partite IVA · Business", href: "#business" },
  { label: "Perché sceglierci", href: "#perche-noi" },
  { label: "Contatti", href: "#contatti" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white pt-20 pb-10">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <a href="#top" className="font-display font-extrabold text-2xl tracking-tight">
            wind<span className="text-brand">online</span>
          </a>
          <p className="mt-4 text-white/50 max-w-xs leading-relaxed">{CONTACT.tagline}. Telefonia, internet e risparmio con consulenza reale.</p>
          <div className="mt-6 flex gap-3">
            <a href={CONTACT.social.instagram} target="_blank" rel="noreferrer" data-testid="social-instagram"
              className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-brand hover:border-brand transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={CONTACT.social.tiktok} target="_blank" rel="noreferrer" data-testid="social-tiktok"
              className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-brand hover:border-brand transition-colors">
              <TikTokIcon className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <p className="text-sm font-bold uppercase tracking-widest text-white/40">Servizi</p>
          <ul className="mt-5 space-y-3">
            {serviceLinks.map((l) => (
              <li key={l.label}><a href={l.href} className="text-white/70 hover:text-brand transition-colors">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-sm font-bold uppercase tracking-widest text-white/40">I nostri negozi</p>
          <ul className="mt-5 space-y-5 text-white/70">
            {STORES.map((s) => (
              <li key={s.id} className="space-y-1">
                <p className="flex items-start gap-2 font-semibold text-white/90"><MapPin className="w-4 h-4 mt-1 text-brand shrink-0" /> {s.address}</p>
                {s.comingSoon && <p className="pl-6 text-xs text-brand font-semibold">{s.comingSoon}</p>}
                {s.phone && <p className="pl-6 flex items-center gap-2"><Phone className="w-4 h-4 text-brand" /> <a href={`tel:${s.phone.tel}`} className="hover:text-brand transition-colors">{s.phone.label}</a></p>}
                {s.email && <p className="pl-6 flex items-center gap-2"><Mail className="w-4 h-4 text-brand" /> <a href={`mailto:${s.email}`} className="hover:text-brand transition-colors break-all">{s.email}</a></p>}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-sm font-bold uppercase tracking-widest text-white/40">Legale</p>
          <ul className="mt-5 space-y-3 text-white/70">
            <li><a href="#" className="hover:text-brand transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-brand transition-colors">Cookie Policy</a></li>
            <li><a href="#contatti" className="hover:text-brand transition-colors">Contatti</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/40">
        <p>© {new Date().getFullYear()} Windonline. Tutti i diritti riservati.</p>
        <p>Moncalieri e Torino · P.IVA 09604530015</p>
      </div>
    </div>
  </footer>
);
